import { render, staticRenderFns } from "./InPractisePerfPhone.vue?vue&type=template&id=320f9e17&"
import script from "./InPractisePerfPhone.vue?vue&type=script&lang=ts&"
export * from "./InPractisePerfPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports